import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required , typeInteger, typeIntegerOrDecimal, typeIntegerOrDecimalOr0, typeIntegerOrDecimalMin10} from "../../common/Validations";
import { 
  Container, 
  Box, 
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  IconButton,
  InputLabel,
  Grid,
  Paper,
  Typography, 
  Tooltip,
  Input,
  InputAdornment,
  Icon,
  Toolbar,
  MenuItem
} from "@material-ui/core"
import ColorField from "../../components/ColorField/ColorField"
import IconPicker from "../../components/IconPicker/IconPicker"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import ImageSelector from '../../components/ImageSelector/ImageSelector'

import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import { actionSaveTicketType, actionGetCategories } from '../../actions/RestaurantActions'
let _handleSubmitFail;
class AddEditTicketType extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={imgEdit:null, imgNameEdit:null, imgError:""}
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    this.onSelectImage=this.onSelectImage.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.props.actionGetCategories(null, (e)=>{console.log("ERROR AL LISTAR CATEGORIAS", e)})
    if(this.props.isEditing){
      let ticket=this.props.history.location.state
      // ticket.tktInitDate = ticket.tktInitDate&&Util.timestampToMoment(ticket.tktInitDate).format('YYYY-MM-DDTHH:mm') 
      // ticket.tktEndDate = ticket.tktEndDate&&Util.timestampToMoment(ticket.tktEndDate).format('YYYY-MM-DDTHH:mm')
      this.props.initialize(ticket)
      this.setState({imgEdit:ticket.mnuImg, imgNameEdit:ticket.mnuImgName})
    }else{
      this.props.initialize({tktVisible:true, mnuHasStock:true, mnuShowOn:'all'})
    }
  }
  
  handleSubmitFail(error){
    if(error.mnuImg){
      this.setState({imgError:error.mnuImg})
    }
    console.log("ERROR EN EL SUBMIT", error)
  }

  onSelectImage(imgUrl, imgBlob, fileName){
    this.props.change("mnuImg", {blob:imgBlob}) //No me deja setear el blob así que lo paso como un objeto con un blob
    this.props.change("mnuImgName", fileName)
    this.setState({imgEdit:imgUrl, imgNameEdit:fileName})
    console.log("SETEO", imgUrl, fileName)
  }

  onClean(){
    this.setState({imgEdit:null, imgNameEdit:null, imgError:""})
    if(this.props.isEditing){
      let ticket=this.props.history.location.state
      this.props.initialize({id:ticket.id, tktVisible:true, mnuHasStock:true, mnuImgPath:ticket.mnuImgPath, mnuShowOn:'all'})
    }else{
      this.props.initialize({tktVisible:true, mnuHasStock:true, mnuShowOn:'all'})
    }
  }

  onSave(formValues){
    let valuesCompatible = {...formValues, mnuTakeAwayDelivery:true}
    if(formValues.mnuShowOn=="table"){
      valuesCompatible.mnuTakeAwayDelivery=false
    }
    this.props.actionSaveTicketType(valuesCompatible
      , ()=>{Util.showNoty(SUCCESS, "El item de menú se guardó correctamente."); this.props.history.goBack()}
      , (e)=>{
        console.log("ERROR ON SAVE ITEM DE MENU", e)
        if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR, "No se pudo guardar el item de menú.")
      }
    )
  }

  render(){
    const { theme, handleSubmit, restaurant, ticketFormValues, categoryList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <Tooltip title="Atrás">
              <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
                <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
              </IconButton>
            </Tooltip>  
          </Box>
          <Box>
            <Typography variant="h1">{restaurant&&restaurant.evtName}</Typography>
            <Typography variant="subtitle1">Crea item de menú</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <Box style={theme.paper.addEditTicketTypeTitle}>
              <Typography style={theme.paper.title} variant="h2">Crear item de menú</Typography>
            </Box>            
            <form style={theme.paper.form}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Field
                    component={TextField}
                    name="tktDisplayName"
                    label="Nombre del ítem"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputLabel shrink fullWidth>Categoría</InputLabel>
                  <Field
                    component={Select}
                    select
                    name="tktCategory"
                    fullWidth
                    validate={[required]}
                  >
                    {categoryList.map((c)=>{
                      return <MenuItem value={c.id}>{c.id}</MenuItem>
                    })}
                  </Field>
                </Grid>
                <Grid item xs={1}>
                  <Field
                    component={TextField}
                    InputProps={{
                      startAdornment:<InputAdornment position="start">$</InputAdornment>
                    }}
                    format={Util.formatNumber}
                    parse={Util.toNumber}
                    name="tktPrice"
                    label="Precio Final"
                    fullWidth
                    validate={[required, typeIntegerOrDecimalMin10]}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Field
                    component={TextField}
                    InputProps={{
                      startAdornment:<InputAdornment position="start">$</InputAdornment>
                    }}
                    format={Util.formatNumber}
                    parse={Util.toNumber}
                    name="tktTablePrice"
                    label="Precio Mesa"
                    fullWidth
                    validate={[required, typeIntegerOrDecimalMin10]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputLabel shrink>Mostrar en</InputLabel>
                  <Field
                    component={Select}
                    name="mnuShowOn"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value="all">Todos</MenuItem>
                    <MenuItem value="table">Mesa</MenuItem>
                    <MenuItem value="deliveryTakeAway">Take Away/Delivery</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={1}>
                  <InputLabel shrink>¿Ítem Visible?</InputLabel>
                  <Field
                    component={Select}
                    name="tktVisible"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value={true}>Si</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={1}>
                  <InputLabel shrink>¿Tiene Stock?</InputLabel>
                  <Field
                    component={Select}
                    name="mnuHasStock"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value={true}>Si</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Field>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                <Tooltip title="Subí la imagen en 375x175">
                  <FormControl fullWidth error={this.state.imgError?true:false}>
                    <ImageSelector
                      fieldName="mnuImg"
                      validate={[required]}
                      fileDimentions={{ width: 750, height: 370 }}
                      styleButton={theme.imageSelector}
                      imagePreviewUrl={this.state.imgEdit}
                      fileName={this.state.imgNameEdit}
                      maxWidth={375}
                      maxHeight={175}
                      fileSize={400000}
                      noPreview
                      onChangeState={()=>{this.setState({imgError:""})}}
                      crop={{
                        aspect: 375/175,
                        x: 0,
                        y: 0,
                        width: 375,
                        height: 175,
                        // unit:"px"
                      }}
                      onSelect={this.onSelectImage}
                    />
                    <FormHelperText>{this.state.imgError}</FormHelperText>
                  </FormControl>
                  </Tooltip>
                </Grid>
                <Grid item xs={8} >
                  <Field
                    component={TextField}
                    name="tktDescription"
                    label="Descripción"
                    fullWidth
                    multiline
                    rows={4}
                    validate={[required]}
                  />
                </Grid>
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>                  
          </Toolbar>
        </Container>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  // console.log("STORE", store)
  return {
    login: store.auth.login,
    restaurant: store.evt.restaurant,
    ticketFormValues: store.form&&store.form.addEditTicketType&&store.form.addEditTicketType.values,
    categoryList: store.evt.categoryList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetCategories,
      actionSaveTicketType
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditTicketType",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditTicketType)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/restaurants/AddEditTicketType.js